import { DeviceTypes } from '../../../constants/DeviceModels';
import type RootStore from '../../root-store';

/**
 * Truck controller
 *
 * @param rootStore
 * @param turnOn
 */
export const truckSwitch = (
  rootStore: RootStore,
  turnOn: boolean = true,
) => {
  const { batchStore, devicesStore } = rootStore;
  const truck = devicesStore.devices.find(v => v.deviceTypeName === DeviceTypes.TruckDevice);

  if (truck) {
    batchStore.deviceStatus.set(truck.id, {
      ...batchStore.getDeviceStatusDefault(truck),
      id: truck.id,
      active: turnOn,
    });
  }
};
